<template>
  <div class="new-year-modal-component">
    <client-only>
      <div>
        <modal :open="show" @close="close" initial-width="1100px">
          <div class="modal-content row">
            <div class="col-md-6">
              <div class="description">
                <div class="m-title">
                  Уважаемые клиенты
                </div>
                <div class="sub-title">
                  Горячая линия по номерам <b>+7 (495) 150-55-22</b> и <br> <b>8 (800) 500-02-20</b> временно не работает,<br> приносим извинения!
                </div>

                <div class="working-hours">
                  <p>Вы можете оформить заказ через наш сайт или приложение.</p>
                </div>
                <div>
                  <Button @click="close" class="button-close">
                    Спасибо, буду знать!
                  </Button>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="image">
                <img src="/modals/sushiset-new-year-popup.png" alt="">
              </div>
            </div>
          </div>
        </modal>
      </div>
    </client-only>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import { mapGetters } from 'vuex'
import Modal from '~/components/page/Modal/Modal'

export default {
  name: 'NewYearModal',
  comments: {
    Modal,
    Button,
  },
  components: { Modal, Button },
  data () {
    return {
      showByTimer: false,
    }
  },
  computed: {
    ...mapGetters({
      showNewYearModal: 'workTime/showNewYearModal',
    }),
    show () {
      return this.showNewYearModal && this.showByTimer
    },

  },
  created () {
    // if (this.showNewYearModal) {
    setTimeout(() => {
      this.showByTimer = true
    }, 2000)
    // }
  },
  methods: {
    close () {
      this.$store.commit('workTime/hideNewYearModal')
    },
    goToDeliveryPage () {
      this.close()
      this.$router.push('/delivery')
    },
  },
}
</script>

<style lang="less" scoped>
.new-year-modal-component {
  ::v-deep {
    .modal_body {
      padding: 0;
    }
  }

  .description {
    min-height: 100%;
    padding: 40px 60px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .m-title {
      font-size: 35px;
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 25px;
      padding-top: 30px;
    }

    .sub-title {
      font-size: 14px;
      line-height: 1.3;
      margin-bottom: 25px;

      span {
        color: @link-color;
        cursor: pointer;
        border-bottom: 1px dotted;

        &:hover {
          border-bottom-color: transparent;
        }

      }
    }

    .working-hours {
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      font-size: 25px;
      line-height: 1.3;
      margin-bottom: 40px;

      p {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 15px;
      }
    }

  }

  .image {

    img {
      max-width: 100%;
      display: block;
      padding: 0;
      margin: 0;
    }

  }
  .button-close {
    display: inline-block;
  }

  @media screen and (max-width: 768px) {

    .row {
      flex-direction: column-reverse;
    }

    .description {
      min-height: 0;
      padding: 15px;
      text-align: center;
      display: block;

      .m-title {
        padding-top: 10px;
        font-size: 28px;
      }

      .sub-title {
        br {
          display: none;
        }
      }

      .working-hours {
        font-size: 20px;
        margin-bottom: 25px;
      }
    }

    .button-close {
      width: 100%;
    }
  }

  ::v-deep {
    .modal_wrap {
      width: calc(100% - 30px);
    }
  }
}

</style>
